<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  {{ data.content }}
  <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px;">
    
    @if(data.isLoading) {
      <mat-spinner></mat-spinner>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>닫기</button>
  @if (data.isActive) {
    <button mat-button (click)="onYesClick()">네</button>
  }
</mat-dialog-actions>
